function CzechRepublic({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1037)">
  <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
  <path d="M14.6087 16C14.6087 16 4.69565 27.3159 4.68628 27.3137C7.58165 30.2091 11.5817 32 16 32C24.8365 32 32 24.8365 32 16H14.6087Z" fill="#D80027"/>
  <path d="M4.68628 4.68555C-1.56209 10.9339 -1.56209 21.0646 4.68628 27.313C7.26834 24.731 9.75165 22.2477 16 15.9993L4.68628 4.68555Z" fill="#0052B4"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default CzechRepublic;
